import React, { useMemo, useState } from "react";
import { Box, GridItem, SimpleGrid, Text } from "@chakra-ui/react";
import StatCard from "../../../components/utils/StatCard";
import {
  MdOutlineCheckCircle,
  MdOutlinePayments,
  MdOutlinePeople,
  MdOutlineSupervisorAccount,
} from "react-icons/md";
import { useDashboardActividades } from "features/dashboard/actividades/hooks";
import { useDashboardInstructores } from "features/dashboard/instructores/hooks";
import { getAvatarHexColor, resolveAvatarUrl } from "utils/avatar";
import StatsChart from "../Instructores/StatsChart";
import ActivityAttendanceChart from "./ActivityAttendanceChart";

const DEFAULT_INSTRUCTOR_ROLE = "Instructor";

const Dashboard = () => {
  const instructoresQ = useDashboardInstructores();
  const actividadesQ = useDashboardActividades();
  const [chartMode, setChartMode] = useState("asistencias");

  const items = useMemo(() => {
    const rows = Array.isArray(instructoresQ.data) ? instructoresQ.data : [];
    return rows
      .map((row) => {
        const id = row?.instructorId;
        const nombre = row?.instructorNombre?.trim() || "Instructor sin nombre";
        const role = row?.instructorRol?.trim() || DEFAULT_INSTRUCTOR_ROLE;

        return {
          id,
          nombre,
          role,
          avatarSrc: resolveAvatarUrl(row) || null,
          asistenciasCount: Number(row?.asistenciasCount ?? 0),
          preceptoriasCount: Number(row?.preceptoriasCount ?? 0),
          avatarColor: getAvatarHexColor(id || nombre),
        };
      })
      .filter((item) => item.id);
  }, [instructoresQ.data]);

  const actividades = useMemo(
    () => (Array.isArray(actividadesQ.data) ? actividadesQ.data : []),
    [actividadesQ.data],
  );

  return (
    <Box>
      <Text fontWeight="semibold" textStyle="4xl">
        Dashboard
      </Text>
      <Text pb="5">Bienvenido a tu dashboard</Text>

      <SimpleGrid pb="5" columns={[2, 4]} gap="2">
        <StatCard title="Socios Registrados" data="28" icon={MdOutlinePeople} tone="info" sub="+2 este mes" />
        <StatCard title="Asistencia Promedio" data="11" icon={MdOutlineCheckCircle} tone="success" sub="78% del grado" />
        <StatCard title="Preceptorias" data="8" icon={MdOutlineSupervisorAccount} tone="warning" sub="Promedio mensual" />
        <StatCard title="Presupuesto Restante" data="3,783" icon={MdOutlinePayments} tone="danger" prefix="$" sub="De $18,000 total" />
      </SimpleGrid>

      {instructoresQ.isError || actividadesQ.isError ? (
        <pre style={{ whiteSpace: "pre-wrap", color: "crimson", marginBottom: 12 }}>
          {String(instructoresQ.error?.message || actividadesQ.error?.message || instructoresQ.error || actividadesQ.error)}
        </pre>
      ) : null}

      <SimpleGrid columns={{ base: 1, lg: 12 }} gap="4" alignItems="start">
        <GridItem colSpan={{ base: 1, lg: 6 }}>
          <StatsChart data={items} mode={chartMode} onModeChange={setChartMode} />
        </GridItem>
        <GridItem colSpan={{ base: 1, lg: 6 }}>
          <ActivityAttendanceChart data={actividades} />
        </GridItem>
      </SimpleGrid>
    </Box>
  );
};

export default Dashboard;
